module.exports = __webpack_public_path__ + "img/esther-jiao-640129-unsplash.9d8d4bdb.jpg";